import React, { FC, Fragment } from 'react'
import { NextSeo } from 'next-seo'
import { NEXT_PUBLIC_IMAGE_ENDPOINT } from 'env'
import { ComponentSharedSeo, Maybe } from '@/gql/generated/graphql'

type Props = {
  data: Maybe<ComponentSharedSeo> | undefined
}

const PageSeo: FC<Props> = (props) => {
  if (!props.data) return null

  return (
    <Fragment>
      <NextSeo
        title={props.data.metaTitle}
        description={props.data.metaDescription}
        canonical={props.data.canonicalURL ?? ''}
        openGraph={{
          title: props.data.metaTitle,
          description: props.data.metaDescription,
          images: [{ url: props.data?.metaImage?.data?.attributes?.url || '' }],
        }}
      />
    </Fragment>
  )
}

export default PageSeo
